import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { tpiApi } from '../api/tpiApi';

export function useTpiCheatsheet(patientId: number | null | undefined) {
  return useQuery({
    queryKey: keys.tpi.cheatsheet(patientId ?? 0),
    queryFn: ({ signal }) => tpiApi.getCheatsheet(patientId!, { signal }),
    enabled: patientId != null,
    staleTime: 120_000,
  });
}
